"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = () => {
    const theme = (0, material_1.useTheme)();
    const cardItem = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '0px',
    };
    const imageBox = {
        width: '100%',
        height: '122px',
        borderRadius: '16px 16px 0px 0px;',
    };
    const contentBox = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '16px 0px',
        gap: '8px',
        width: '100%',
    };
    const titleStyles = {
        display: '-webkit-box',
        color: theme.qlub.palette.onSurfaceColors.highEmphasis,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
    };
    const descriptionStyles = {
        fontFamily: 'inherit',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '139.02%',
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitLineClamp: '3',
        WebkitBoxOrient: 'vertical',
        letterSpacing: '0.004em',
        color: theme.qlub.palette.onSurfaceColors.mediumEmphasis,
    };
    return {
        cardItem,
        imageBox,
        contentBox,
        descriptionStyles,
        titleStyles,
    };
};
exports.default = useStyle;
